/**
 * Project selection list card layout + typography.
 * Card titles stay distinct from pageShell.sectionTitle (hero list on selection page).
 */

export const projectListShell = {
    section: "mx-auto grid w-full max-w-[42rem] grid-cols-1 gap-4 p-0",
    card:
        "group flex min-h-[4.5rem] cursor-pointer items-center justify-start rounded-lg border border-solid border-border bg-surface px-4 py-4 text-text-primary shadow-none transition-colors duration-200 hover:border-button-primary focus:border-button-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-button-primary motion-reduce:transition-none bp-lg:px-5 bp-lg:py-4",
    cardInner: "relative flex w-full items-center gap-4",
    iconBox:
        "flex size-11 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-button-primary bp-lg:size-12",
    iconSvg: "size-5 text-text-inverse",
    titleWrap: "flex min-w-0 flex-1 flex-col gap-1",
    title:
        "m-0 break-words text-lg font-semibold leading-snug text-text-primary bp-lg:text-xl bp-2xl:text-2xl group-hover:text-button-primary",
};
